import styled from 'styled-components';

export const StyledSpan = styled.span`
  display: inline-flex;
  align-items: center;
  margin-top: ${({ theme }) => theme.spacing.space_2};
  margin-left: ${({ theme }) => theme.spacing.space_4};
  font-size: ${({ theme }) => theme.font.size.small};
  font-weight: normal;
  line-height: 20px;

  a {
    display: inline-flex;
    align-items: center;
    gap: ${({ theme }) => theme.spacing.space_2};
    color: var(--text-color);
    transition: color 0.3s;
  }

  a:hover,
  a:focus {
    color: var(--primary-color);
  }

  .anticon {
    font-size: ${({ theme }) => theme.font.size.xsmall};
  }
`;
